import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, EventEmitter,
  Output
} from '@angular/core';
import {IshowRecommendedList} from "@ispm-client/modules/selection-item/interfaces/floatingPanel.interface";
import {get} from 'lodash';

@Component({
  selector: 'recommended-list',
  templateUrl: './recommended-list.component.html',
  styleUrls: ['./recommended-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RecommendedListComponent implements OnInit {

  private selectedItems: Array<any>;
  @Input()  public showRecommendedList: IshowRecommendedList;

  public prioritizeAvailable: boolean = false;

  @Input() public noData: boolean;

  @Input() public permitItemSelectionWrite: boolean;

  public recommendedListItemName: string = null;
  @Input() set recommendedListItem(recommendedListItem: string) {
    this.recommendedListItemName = recommendedListItem;
    this.showRecommendedListItems();
  }

  get recommendedListItem() {
    return this.recommendedListItemName;
  }

  @Input() public  expandCollapseRequired: boolean;

  @Input() public expandRecommendedList: boolean;

  public recommendedListItems: Array<any>;
  @Input() set totalSelectedItemList(totalSelectedItemList: Array<any>) {
    this.selectedItems = totalSelectedItemList;
    this.showRecommendedListItems();
  }

  get totalSelectedItemList() {
    return this.recommendedListItems;
  }

  @Output()
  emitRecommendedItems: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _changeDetector: ChangeDetectorRef){}

  ngOnInit() {
    this.prioritizeAvailable = get(this.showRecommendedList, 'prioritizeAvailable');
  }


  /**
   * Create format for dynamicFormTable to display the selectedRecommendationList
   * @param {Array<any>} totalSelectedItemList
   * @returns {Array<any>}
   */
  createListFormat(totalSelectedItemList: Array<any>): Array<any> {
    let recommendedItems = [];
    if (totalSelectedItemList) {
      totalSelectedItemList.forEach((item, index) => {
        recommendedItems = [];
        if(item.itemReferences && item.itemReferences.length > 0) {
          item.itemReferences.map(itemReference => recommendedItems.push(itemReference.display));
        }
        let itemDetails = null;
        if(item.itemName) {
          itemDetails = item.itemName;
        } else if(get(item, 'formData') && get(item.formData, this.recommendedListItemName)){
          itemDetails = item.formData[this.recommendedListItemName];
        }

        itemDetails = itemDetails && itemDetails['display'] ? itemDetails.display : itemDetails;
        recommendedItems.push(itemDetails);
        totalSelectedItemList[index].itemRecommendedPath = recommendedItems.join(' : ');
      });
    }
    return totalSelectedItemList;
  }

  showRecommendedListItems() {
    if(this.recommendedListItemName && this.selectedItems) {
      this.recommendedListItems = this.createListFormat(this.selectedItems);
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
  }

  /**
   * triggers an event on drag and drop of items
   * @param event
   */
  updateContainedData(event) {
    this.totalSelectedItemList = event;
    this.emitRecommendedItems.emit(this.totalSelectedItemList);
  }

  /**
   * triggers an event on delete of item
   * @param event
   */
  deleteItemHanlder(event) {
    this.totalSelectedItemList = event.dataArray;
    this.emitRecommendedItems.emit(this.totalSelectedItemList);
   // this.showItemsCount();
  }

  expandCollapseList() {
    this.expandRecommendedList = !this.expandRecommendedList;
  }

}

